module.exports = __webpack_public_path__ + "media/payment_networks/robinhood-bfc9a82d.png";